module.exports = __webpack_public_path__ + "site-68.jpg?731e95b1256018b6f845490035d77b85";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-68.jpg
 ** module id = 178
 ** module chunks = 0
 **/